export type UserRole = 'admin' | 'branch_manager' | 'inventory_manager';

export interface PermissionConfig {
  dashboard: UserRole[];
  inventory: UserRole[];
  sales: UserRole[];
  customers: UserRole[];
  dealers: UserRole[];
  expenses: UserRole[];
  reports: UserRole[];
  settings: UserRole[];
}

export const PERMISSIONS: PermissionConfig = {
  dashboard: ['admin', 'branch_manager'],
  inventory: ['admin', 'branch_manager', 'inventory_manager'], 
  sales: ['admin', 'branch_manager'],
  customers: ['admin', 'branch_manager'],
  dealers: ['admin', 'branch_manager'],
  expenses: ['admin', 'branch_manager'],
  reports: ['admin'],
  settings: ['admin']
};

export const checkPermission = (userRole: UserRole | undefined, resource: keyof PermissionConfig): boolean => {
  if (!userRole) return false;
  return PERMISSIONS[resource].includes(userRole);
};

export const getAccessDeniedMessage = (userRole: UserRole | undefined, resource: string): string => {
  const roleNames = {
    'admin': 'Administrator',
    'branch_manager': 'Branch Manager', 
    'inventory_manager': 'Inventory Manager'
  };

  const roleName = userRole ? roleNames[userRole] : 'User';

  return `Access Denied: ${roleName} role does not have permission to access ${resource}. Please contact your administrator if you believe this is an error.`;
};